import parameters from '@atlassian/jira-relay/src/__generated__/InlineCreateAdditionalFieldsEntrypointQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = {
	cloudId: string;
	projectKey: string | null;
};

export const InlineCreateAdditionalFieldsEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-inline-create-additional-fields" */ './src/ui/InlineCreateAdditionalFieldsEntrypoint'
			),
	),
	getPreloadProps: ({ cloudId, projectKey }: EntryPointParams) =>
		({
			queries: {
				rootData: {
					parameters,
					variables: {
						cloudId,
						projectKey: projectKey ?? '',
						hasProjectKey: !!projectKey,
					},
				},
			},
		}) as const,
});
